import { render, staticRenderFns } from "./TaskListIcon.vue?vue&type=template&id=0bc59ba7&"
import script from "./TaskListIcon.vue?vue&type=script&lang=js&"
export * from "./TaskListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports